// Shared UTM convention for every outbound PositiveNav link.
export const trackingDefaults = Object.freeze({
  source: 'positive_nav',
  medium: 'referral',
  fallbackCampaign: 'positive',
  placements: Object.freeze({
    product: 'bar',
    preview: 'preview',
    catalog: 'all_products',
    productPanel: 'product_panel',
  }),
  actions: Object.freeze({
    app: 'login',
    try: 'try_free',
    discover: 'discover',
  }),
});
